import http from '@core/fetch'
export default {
  getResultApi: body =>
    http(`/p/wedding/index.php/Admin/APIOrderCommentAppeal/detail`, { body }), //获取申诉结果
  //获取问答的申诉结果
  getResult_questionApi: body =>
    http('/p/wedding/admin/APIQaMerchantAppeal/detail', { body })
}
